import firebase from 'firebase/app'
import 'firebase/database'

let config = {
  databaseURL: "https://flora-2b033.firebaseio.com",
};


export const db = firebase
    .initializeApp(config)
    .database();


